import { useState, type FormEvent } from 'react';

export default function SubscribeBar() {
  const [email, setEmail] = useState('');
  const [guard, setGuard] = useState('');
  const [status, setStatus] = useState<'idle' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (guard.trim() !== '') {
      setStatus('done');
      setMessage('已收到，感谢加入吃瓜大军。');
      return;
    }
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!valid) {
      setStatus('error');
      setMessage('请填写有效的邮箱地址，方便我们回你。');
      return;
    }
    setStatus('done');
    setMessage('已登记成功，热评风向会第一时间送到你邮箱。');
    setEmail('');
  };

  return (
    <section id="subscribe" className="w-full">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16 lg:px-10">
        <div className="overflow-hidden rounded-lg border bg-background-50 hairline">
          <div className="grid grid-cols-1 lg:grid-cols-12">
            <div className="border-b bg-secondary-50 p-6 md:p-8 lg:col-span-5 lg:border-b-0 lg:border-r hairline">
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-500 px-3 py-1 text-xs font-bold text-background-50">
                <i className="ri-notification-3-line text-sm"></i>
                加入吃瓜大军
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950">
                热评风向，第一时间送到
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                留下邮箱，我们会把爱黑料网评论区的当日高赞、讨论区的新风向，整理成一封简报送给你。
              </p>
              <ul className="mt-5 space-y-2.5">
                {['每日热评精选', '反转时间线提醒', '合集更新通知'].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-foreground-700">
                    <i className="ri-checkbox-circle-line text-base text-secondary-600"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="p-6 md:p-8 lg:col-span-7">
              <form onSubmit={handleSubmit} data-readdy-form="home-subscribe" noValidate>
                <label
                  htmlFor="subscribe-email"
                  className="text-sm font-semibold text-foreground-800"
                >
                  邮箱地址
                </label>
                <div className="mt-2 flex flex-col gap-3 sm:flex-row">
                  <div className="flex h-12 flex-1 items-center gap-2 rounded-md border bg-background-100 px-3.5 hairline focus-within:border-primary-300">
                    <i className="ri-mail-line text-base text-foreground-400"></i>
                    <input
                      id="subscribe-email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (status !== 'idle') setStatus('idle');
                      }}
                      placeholder="you@example.com"
                      className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                    />
                  </div>
                  <button
                    type="submit"
                    className="h-12 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    订阅简报
                  </button>
                </div>

                <input
                  className="form-guard-field"
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  value={guard}
                  onChange={(e) => setGuard(e.target.value)}
                />

                <p className="mt-3 text-xs leading-relaxed text-foreground-500">
                  我们只发送站内热评与合集更新，随时可以退订。
                </p>

                {status !== 'idle' && (
                  <p
                    className={`mt-4 flex items-center gap-2 rounded-md px-3.5 py-2.5 text-xs font-semibold ${
                      status === 'done'
                        ? 'bg-secondary-100 text-secondary-900'
                        : 'bg-primary-100 text-primary-800'
                    }`}
                  >
                    <i
                      className={`text-sm ${
                        status === 'done' ? 'ri-checkbox-circle-line' : 'ri-error-warning-line'
                      }`}
                    ></i>
                    {message}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}